// extracted by mini-css-extract-plugin
module.exports = {"eventDate":"EventDate_eventDate__MEXuD","eventDateLabel":"EventDate_eventDateLabel__zhd6C","eventDateValue":"EventDate_eventDateValue__yRfBE"};